import { breakpoints, css } from '../../../styles/theme';
import { rem } from 'polished';
import { FilterBoxProps } from './index';

export const StylesAP = css<FilterBoxProps>`
    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(13)} ${rem(26)};
        ${({ isHomepage, theme }) => (isHomepage ? '' : `border-bottom: 2px solid ${theme.colors.primary};`)}
    }

    .filterbox-body {
        & > div:nth-child(n) {
            max-width: ${rem(350)};

            @media (max-width: ${breakpoints.md}px) {
                max-width: unset;
            }
        }
    }

    .price-geoLocation-container {
        @media (min-width: ${breakpoints.md}px) {
            margin-top: ${rem(25)};
        }
    }

    .geolocation-input-container {
        margin-top: ${rem(70)};
    }

    .geolocation-filter-label {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        margin-top: ${rem(85)};
    }

    .budgetWrapper {
        .budget {
            margin: ${rem(12)} 0;
        }
    }

    .reset-filters--button {
        font-family: ${({ theme }) => theme.fonts.fontBase} !important;

        @media (min-width: ${breakpoints.md}px) {
            position: absolute;
            bottom: ${rem(16)};
        }
    }

    .filter-buttons-wrapper {
        .slider-over {
            @media (min-width: ${breakpoints.md}px) {
                top: ${rem(15)};
            }
        }
    }

    .filterbox-collapse-button {
        background: ${({ theme }) => theme.colors.grey2};
        font-size: ${rem('11px')};
        border-radius: 0 0 ${rem('11px')} ${rem('11px')};
        z-index: 9;
        .icon-wrapper {
            height: unset;
        }
    }
`;
